/**
 * AdminAccess Component
 * 
 * Administrative access page for the wedding website.
 * Handles master password authentication for different admin levels.
 */

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Login.css'; // Reuse Login styles

// Import centralized auth utilities
import { setAuthSession } from '../utils/auth';

function AdminAccess() {
  const [error, setError] = useState('');
  const [masterPassword, setMasterPassword] = useState('');
  const navigate = useNavigate();

  const verifyMasterPassword = () => {
    const masterPass = masterPassword.trim();
    // Regular master password - redirects to Full Agenda
    if (masterPass === 'RadhikaVivek2025') {
      setError('');
      // Set master authentication using centralized utility
      setAuthSession('Master Admin', 'admin');
      // Navigate to Full Agenda page
      navigate('/fllagnd8293kxm');
    } 
    // Super master password - redirects to Private Agenda (Admin Agenda)
    else if (masterPass === 'SuperAdmin2025RV') {
      setError('');
      // Set super master authentication using centralized utility
      setAuthSession('Super Admin', 'super_admin');
      // Navigate to Private Agenda (Admin Agenda)
      navigate('/prxivtaeagnd7283');
    }
    // CreateLink-only admin password - redirects to CreateLink page only
    else if (masterPass === 'LinkAdmin2025') {
      setError('');
      // Set CreateLink admin authentication using centralized utility
      setAuthSession('Link Admin', 'link_admin');
      // Navigate to CreateLink page
      navigate('/crtlnk9472xwz');
    } else {
      setError('❌ Invalid master password.');
      setMasterPassword(''); // Clear master password field on failure
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      verifyMasterPassword();
    }
  };

  const goBackToLogin = () => {
    navigate('/');
  };

  return (
    <div className="login-container">
      {/* Envelope flap */}
      <div className="envelope-flap">
        <img src="/envelop_flap.png" alt="Envelope Flap" className="envelope-flap-image" />
      </div>
      
      {/* Hero text overlay similar to reception page */}
      <div className="login-hero-text">
        <h1>Radhika & Vivek</h1>
        <p>Administrator Access</p>
      </div>
      
      <div className="login-card">
        <div className="login-header">
          <h2>Radhika & Vivek</h2>
          <p>Enter master password to access administrative features</p>
        </div>

        <div className="login-form">
          <div className="input-group">
            <label htmlFor="masterPassword">Master Password:</label>
            <input
              type="password"
              id="masterPassword"
              value={masterPassword}
              onChange={(e) => setMasterPassword(e.target.value)}
              onKeyPress={handleKeyPress}
              placeholder="Enter master password"
            />
          </div>

          <button onClick={verifyMasterPassword} className="submit-button">
            Access Website
          </button>
          
          <button 
            onClick={goBackToLogin} 
            className="submit-button"
            style={{marginTop: '10px', backgroundColor: '#666'}}
          >
            Back to Login
          </button>

          {error && <p className="error">{error}</p>}
        </div>

        <div className="login-footer">
          <p>Administrative access only</p>
        </div>
      </div>
      
      {/* Transparent footer with flower images */}
      <div className="login-page-footer">
        <div className="footer-flowers">
          <img src="/aboli.png" alt="Aboli Flower" className="footer-flower" />
          <img src="/marigold.png" alt="Marigold Flower" className="footer-flower" />
        </div>
      </div>
    </div>
  );
}

export default AdminAccess;